/**
 * Cache name used by the hand-written service worker of the previous version.
 *
 * Workbox's `cleanupOutdatedCaches` only removes precaches Workbox itself
 * created, so this one survives the upgrade. On a tablet that already had the
 * app installed it holds a frozen copy of the old index.html, which the old
 * worker served offline-first — meaning the new version could stay invisible
 * indefinitely. Deleting it from the client is the reliable way out.
 */
const LEGACY_CACHE = 'jdc-anso-v9';

export async function dropLegacyCache(): Promise<void> {
  if (typeof caches === 'undefined') return;

  try {
    await caches.delete(LEGACY_CACHE);
  } catch {
    // A private-mode browser can refuse cache access; nothing here is
    // important enough to interrupt startup over.
  }
}
